import { render, staticRenderFns } from "./dryEyeTreatment.vue?vue&type=template&id=6ecf5382&scoped=true&"
import script from "./dryEyeTreatment.vue?vue&type=script&lang=js&"
export * from "./dryEyeTreatment.vue?vue&type=script&lang=js&"
import style0 from "./dryEyeTreatment.vue?vue&type=style&index=0&id=6ecf5382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf5382",
  null
  
)

export default component.exports